import React, { useState, useEffect } from 'react';
import { Modal, Button, Spinner, Alert, Table, Row, Col } from 'react-bootstrap';
import { getFatturaPreview } from '../../services/api';

function PreviewFatturaModal({ show, handleClose, ordineId, onConfirm }) {
  const [previewData, setPreviewData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (show && ordineId) {
      const fetchPreview = async () => {
        setLoading(true);
        setError(null);
        setPreviewData(null);
        try {
          const response = await getFatturaPreview(ordineId);
          setPreviewData(response.data);
        } catch (err) {
          setError('Impossibile caricare \'anteprima della fattura.');
          console.error(err);
        } finally {
          setLoading(false);
        }
      };
      fetchPreview();
    }
  }, [show, ordineId]);

  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Anteprima Fattura</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading && <div className="text-center"><Spinner animation="border" /></div>}
        {error && <Alert variant="danger">{error}</Alert>}
        {previewData && (
          <div>
            <Row className="mb-4">
              <Col md={6}>
                <h5>Dati Azienda</h5>
                <strong>{previewData.dati_azienda.denominazione}</strong><br/>
                {previewData.dati_azienda.indirizzo}<br/>
                P.IVA: {previewData.dati_azienda.piva}
              </Col>
              <Col md={6} className="text-md-end">
                <h5>Dati Documento</h5>
                <strong>Fattura N. (proposto):</strong> {previewData.documento.numero}<br/>
                <strong>Data:</strong> {new Date(previewData.documento.data).toLocaleDateString()}
              </Col>
            </Row>

            <hr/>

            <Row className="mb-3">
              <Col>
                <h5>Cliente</h5>
                <strong>{previewData.cliente.denominazione_sociale || `${previewData.cliente.nome} ${previewData.cliente.cognome}`}</strong><br/>
                {previewData.cliente.indirizzo}, {previewData.cliente.cap} {previewData.cliente.citta} ({previewData.cliente.provincia})<br/>
                {previewData.cliente.piva && `P.IVA: ${previewData.cliente.piva}`}{previewData.cliente.cf && ` / CF: ${previewData.cliente.cf}`}
              </Col>
            </Row>

            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>Codice</th>
                  <th>Descrizione</th>
                  <th className="text-end">Qtà</th>
                  <th className="text-end">Prezzo Unit.</th>
                  <th className="text-end">IVA %</th>
                  <th className="text-end">Imponibile</th>
                </tr>
              </thead>
              <tbody>
                {previewData.documento.righe.map((riga, index) => (
                  <tr key={index}>
                    <td>{riga.codice}</td>
                    <td>{riga.descrizione}</td>
                    <td className="text-end">{riga.qty}</td>
                    <td className="text-end">€ {riga.prezzo.toFixed(2)}</td>
                    <td className="text-end">{riga.iva}%</td>
                    <td className="text-end">€ {riga.imponibile.toFixed(2)}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
            
            <Row className="justify-content-end text-end mt-3">
                <Col md={5}>
                    <p className="d-flex justify-content-between mb-1"><strong>Imponibile:</strong> <span>€ {previewData.documento.imponibile.toFixed(2)}</span></p>
                    <p className="d-flex justify-content-between mb-1"><strong>IVA:</strong> <span>€ {previewData.documento.iva.toFixed(2)}</span></p>
                    <p className="d-flex justify-content-between mb-1"><strong>Spese Spedizione:</strong> <span>€ {previewData.documento.spese_spedizione.toFixed(2)}</span></p>
                    <hr />
                    <h5 className="d-flex justify-content-between mb-1"><strong>Totale Documento:</strong> <span>€ {previewData.documento.totale.toFixed(2)}</span></h5>
                    <p className="d-flex justify-content-between mb-1"><strong>Acconto:</strong> <span>€ {previewData.documento.acconto.toFixed(2)}</span></p>
                     <h5 className="d-flex justify-content-between"><strong>Saldo:</strong> <span>€ {(previewData.documento.totale - previewData.documento.acconto).toFixed(2)}</span></h5>
                </Col>
            </Row>
             {previewData.documento.note && (
                <Row className="mt-4">
                    <Col>
                        <h6>Note:</h6>
                        <p>{previewData.documento.note}</p>
                    </Col>
                </Row>
            )}
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Annulla
        </Button>
        <Button variant="primary" onClick={onConfirm} disabled={loading || !previewData}>
          Conferma e Crea
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default PreviewFatturaModal;
